<template>
  <div>
    <ReportItemContainer v-if="isReportMode">
      <template #question>{{ question.text }}</template>
      <template #answer>
        <p>{{ inputDate }}</p>
      </template>
    </ReportItemContainer>
    <div v-else>
      <p>{{ question.text }}</p>
      <DateInput
        :value="inputDate"
        :is-disabled="isReadOnlyMode"
        @update-event="updateDate"
        @valid="emitValid"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import DateInput from "@/components/custom/DateInput.vue";
import ReportItemContainer from "@/components/containers/ReportItemContainer.vue";
import type { QuestionModelDto } from "@/models/dto/questionModelDto";

const props = withDefaults(
  defineProps<{
    questionModel: QuestionModelDto;
    answer?: string | object | null;
    isReportMode?: boolean;
    isReadOnlyMode?: boolean;
  }>(),
  {
    isReportMode: false,
    isReadOnlyMode: false,
  }
);

const emit = defineEmits<{
  (e: "qEvent", newDate: string): void;
  (e: "isValid", isValid: boolean, invalidField: string): void;
}>();

const inputDate = ref((props.answer as unknown as string) ?? "");
const question = computed(() => props.questionModel?.question);

function updateDate(newDate: string): void {
  inputDate.value = newDate;
  emitNewDate();
}

function emitNewDate(): void {
  emit("qEvent", inputDate.value);
}

function emitValid(isValid: boolean): void {
  emit("isValid", isValid, question.value.id);
}
</script>
